import script from "./PasswordResetRequestForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordResetRequestForm.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordResetRequestForm.vue?vue&type=style&index=0&id=683a0408&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683a0408"]])

export default __exports__